import request from '@/utils/request'

// 主营类目商品统计
export function getProductStatistical (params) {
  return request({
    url: '/product/statistical/product',
    method: 'get',
    params
  })
}
// 主营类目分析
export function getStatisticalAnalysis (params) {
  return request({
    url: '/product/statistical/analysis',
    method: 'get',
    params
  })
}
// 主营类目销售统计
export function getCategoryStatistical (params) {
  return request({
    url: '/product/statistical/category/statistical',
    method: 'get',
    params
  })
}
// 商品销售统计
export function getSalesStatistical (params) {
  return request({
    url: '/product/statistical/sales/statistical',
    method: 'get',
    params
  })
}

//用户访问统计
export function getVisitList (params) {
  return request({
    url: '/visit/list',
    method: 'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/mainCategoryStatistics.js